const PRO_WHITE = {
  name: 'Pro White',
  font: "montserrat",
  fontColor: "#2c3e50",
  fontColor2: "#2c3e50",
  bgColor: "#FFFFFF",
  accentColor: "#1DA1F2",
  panelColor: "#FFFFFF",
  button_fontColor: "#2c3e50",
  button_bgColor: "#FFFFFF",
  button_border: "#e5e7eb",
};

const PRO_BLUE = {
  name: 'Pro Blue',
  font: "montserrat",
  fontColor: "#FFFFFF",
  fontColor2: "#2c3e50",
  bgColor: "#3D556E",
  accentColor: "#FF6A88",
  panelColor: "#FFFFFF",
  button_fontColor: "#E8E8E8",
  button_bgColor: "#3CC49C",
  button_border: "#3CC49C",
};

const BROWN_BETTY = {
  name: 'Brown Betty',
  font: "open_sans",
  fontColor: "#FAB3A9",
  fontColor2: "#2c3e50",
  bgColor: "#463239",
  accentColor: "#ED6B86",
  panelColor: "#FFFFFF",
  button_fontColor: "#FFFFFF",
  button_bgColor: "#57b894",
  button_border: "#57b894",
};

const BLUE_BETTY = {
  name: 'Blue Betty',
  font: "open_sans",
  fontColor: "#1A3A4B",
  fontColor2: "#1A3A4B",
  bgColor: "#CAE9FF",
  accentColor: "#00C6AF",
  panelColor: "#FFFFFF",
  button_fontColor: "#FFFFFF",
  button_bgColor: "#00A1F3",
  button_border: "#00A1F3",
};

const GREEN_JOE = {
  name: 'Green Joe',
  font: "poppins",
  fontColor: "#FFFFFF",
  fontColor2: "#05386B",
  bgColor: "#57b894",
  accentColor: "#FA875F",
  panelColor: "#FFFFFF",
  button_fontColor: "#FFFFFF",
  button_bgColor: "#57b894",
  button_border: "#FFFFFF",
};

const APPSTER = {
  name: 'Appster',
  font: "noto_sans",
  fontColor: "#FFFFFF",
  fontColor2: "#14171A",
  bgColor: "#1DA1F2",
  accentColor: "#FF6A88",
  panelColor: "#FFFFFF",
  button_fontColor: "#FFFFFF",
  button_bgColor: "#1da1f21a",
  button_border: "#FFFFFF",
};

import Survey from "@/models/Survey";
import Button from "@/models/Button";

export const Templates = {
  computed: {
    schemes(){
        return { PRO_WHITE, PRO_BLUE, BROWN_BETTY, BLUE_BETTY, GREEN_JOE, APPSTER }
    },
  },
  methods: {
    applyTemplate(template) {
      Survey.update({
        where: this.survey.id,
        data: {
          font: template.font,
          fontColor: template.fontColor,
          fontColor2: template.fontColor2,
          bgColor: template.bgColor,
          accentColor: template.accentColor,
          panelColor: template.panelColor,
        },
      });

      Button.update({
        where: this.survey.buttons[0].id,
        data: {
          fontColor: template.button_fontColor,
          bgColor: template.button_bgColor,
          borderColor: template.button_border,
        },
      });
    },
  },
};
